import { InvoiceContractScreenData } from "@/modules/facturae/domain/InvoiceContractScreenData";

export class VueInvoiceContractScreenData implements InvoiceContractScreenData{
  loading: boolean;
  showTrial:boolean  
  

  constructor(){
    this.loading = false
    this.showTrial = false
  }
  
  setLoading(loading:boolean){
    this.loading = loading
  }
  setShowTrial(show_trial:boolean) {
    this.showTrial = show_trial
  }

}